$(function ($) {
    "use strict";

    $('[site-expander]').each(function () {
        var $element = $(this);

        var readmore = $element.attr('site-expander');
        var desktopMode = $element.attr('site-expander-desktop') !== undefined;

        var maxHeight = $element.css('max-height');
        if (maxHeight === 'none') {
            maxHeight = $element.data('max-height') || '15em';
        }

        var isMobile = window.innerWidth < 768;

        function resize() {

            if (desktopMode || isMobile) {

                if (!$element.hasClass('site-expander-clicked')) {

                    var $html = $("<div class='site-expander-center'><div class='btn site-btn-showmore site-expander-btn'>" + readmore + "</div></div>");

                    $html.find('.site-expander-btn').on('click', function () {
                        $element.removeClass("site-expander--collapsed").css('max-height', '');
                        $element.addClass('site-expander-clicked');
                        $html.remove();
                    });

                    if (!$element.find('.site-expander-btn').length) {
                        $element
                            .addClass('site-expander--collapsed')
                            .css('max-height', maxHeight)
                            .append($html);
                    }
                }
            }

        }

        $(window).on('resize', resize);
        resize();

    });


    $('[site-expander-small]').each(function () {
        var $element = $(this);

        var readmore = $element.attr('site-expander-small');

        var maxHeight = $element.css('max-height');
        if (maxHeight === 'none') {
            maxHeight = $element.data('max-height') || 'calc(' + $element.css('line-height') + ' * 3)';
        }

        function resize() {
            if (!$element.hasClass('site-expander-clicked')) {

                var $html = $("<div class='site-expander-center'><div class='btn site-btn-showmore site-expander-small-btn'>" + readmore + " +</div></div>");

                $html.find('.site-expander-small-btn').on('click', function () {
                    $element.removeClass("site-expander--collapsed").css('max-height', '');
                    $element.addClass('site-expander-clicked');
                    $html.remove();
                });

                if (!$element.find('.site-expander-small-btn').length) {
                    $element
                        .addClass('site-expander--collapsed')
                        .css('max-height', maxHeight)
                        .append($html);
                }
            }
        }

        $(window).on('resize', resize);
        resize();

    });

});
//            }
//        }

//        $(window).on('resize', resize);
//        resize();

//    });

//});